export const PDF_FILE_URL = 'https://firebasestorage.googleapis.com/v0/b/mpro-mvp.appspot.com/o/รายละเอียดเพิ่มเติม%20MProp.pdf?alt=media&token=2275576b-bf1f-4881-ade9-70679b2820ca'
